import Reflux from 'reflux';

const StripeActions = Reflux.createActions(['change']);

export default StripeActions;



// WEBPACK FOOTER //
// ./src/js/actions/Stripe.js